



























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { triggerWindowResizeEvent } from '@/utils/util'
import Task from '@/web-task'
import TaskApi from '@/api/task'
const DAI_CHU_LI = '1'
const CHU_LI_ZHONG = '2'
const YI_CHU_LI = '3'
const YI_HU_LVE = '4'

@Component({})
export default class riskSection extends Vue {
	private riskSlideUp: boolean = false
	private interval: any = ''
	private timeoutTimer: any = ''

	@Prop()
	private riskList!: any

	@Prop()
	private modelInfo!: any

	@Prop()
	private insuranceType!: string

	@Prop({ default: false })
	private isModal!: boolean

	private get list() {
		if (this.riskList && this.riskList.length) {
			return this.riskList
		} else {
			return [{}]
		}
	}

	private get rate() {
		if (this.modelInfo) {
			const score = this.modelInfo.score || 0
			const rate = score / 20
			if (Math.round(rate) === Math.floor(rate)) {
				return Math.floor(rate)
			} else {
				return Math.floor(rate) + 0.5
			}
		} else {
			return 0
		}
	}

	private riskSlideToggle() {
		this.riskSlideUp = !this.riskSlideUp

		if (this.interval) {
			clearInterval(this.interval)
		}
		if (this.timeoutTimer) {
			clearTimeout(this.timeoutTimer)
		}
		this.interval = setInterval(() => {
			this.$nextTick(() => {
				triggerWindowResizeEvent()
			})
		}, 16)

		// 等待动画时长
		this.timeoutTimer = setTimeout(() => {
			if (this.interval) {
				clearInterval(this.interval)
			}
		}, 400)
	}
}
